import {
	Button,
	Dialog,
	DialogActions,
	DialogClose,
	DialogContent,
	DialogPopup,
	DialogTitle,
} from '@huntington/honeycomb';
import { Typography } from '@mui/material';
import {
	DISCLOSURE_CANCELLATION_HEADER,
	DISCLOSURE_CANCELLATION_TOP_MESSAGE,
	DISCLOSURE_CANCELLATION_BOTTOM_MESSAGE,
	DISCLOSURE_CANCELLATION_CANCEL_BUTTON,
	DISCLOSURE_CANCELLATION_LEAVE_BUTTON,
} from '../../../constants/messages';

type DisclosureCancellationModalProps = {
	open: boolean;
	onClose: () => void;
	onLeave: () => void;
};

export const DisclosureCancellationModal = ({
	open,
	onClose,
	onLeave,
}: DisclosureCancellationModalProps) => {
	return (
		<Dialog
			open={open}
			onOpenChange={(nextOpen: boolean) => {
				if (!nextOpen) onClose();
			}}
		>
			<DialogPopup>
				<DialogTitle style={{ 
						display: 'flex',
						padding: '0.5rem 4.5rem 0 1rem',
						minHeight: '4rem',
						alignItems: 'center',
						alignSelf: 'stretch',
						gap: '0.625rem',}}>
					<DialogClose tabIndex={-1} />
					{DISCLOSURE_CANCELLATION_HEADER}
				</DialogTitle>

				<DialogContent>
					<Typography sx={{ whiteSpace: 'pre-line', paddingBottom: '1rem' }}>{DISCLOSURE_CANCELLATION_TOP_MESSAGE}</Typography>
					<Typography sx={{ whiteSpace: 'pre-line'}}>{DISCLOSURE_CANCELLATION_BOTTOM_MESSAGE}</Typography>
				</DialogContent>

				<DialogActions
					style={{
						display: 'flex',
						padding: '1rem',
						justifyContent: 'flex-end',
						alignItems: 'flex-end',
						gap: '1.5rem',
						flex: '1 0 0',
						alignSelf: 'stretch',
					}}
				>
					<Button priority="secondary" onClick={onClose}>
						{DISCLOSURE_CANCELLATION_CANCEL_BUTTON}
					</Button>
					<Button priority="primary" onClick={onLeave}>
						{DISCLOSURE_CANCELLATION_LEAVE_BUTTON}
					</Button>
				</DialogActions>
			</DialogPopup>
		</Dialog>
	);
};
